import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getSinglePromotionAPI, deletePromotionAPI, fetchPromotionListingAPI, updatePromotionAPI, createPromotionAPI, getPromotionProductRulesByTypeAPI, getPromotionCartRulesByTypeAPI, downloadPromotionAsPdfAPI, createPromoAPI, updatePromoAPI, deletePromoAPI, getAllPromotionsAPI, getPromotionDataAPI, fetchPromotionPlatformProducts, fetchPromotionPlatformCategories, fetchPromotionPlatformBrands } from "../../redux/apis/promotion";
import { data } from "browserslist";


export const createPromotion = createAsyncThunk(
    'promotion/createPromotion',
    async (data, { rejectWithValue }) => {
        try {
            const res = await createPromotionAPI(data);
            return res;
        } catch (error) {
            
            return rejectWithValue(error.response?.data);
        }
    }
);

export const updatePromotion = createAsyncThunk(
    'promotion/updatePromotion',
    async ({ data, promotionId }, { rejectWithValue }) => {
        try {
            const res = await updatePromotionAPI(data, promotionId);
            return res;
        } catch (error) {
            
            return rejectWithValue(error.response?.data);
        }
    }
);

export const updatePromo = createAsyncThunk(
    'promotion/updatePromo',
    async ({ data, promoId }, { rejectWithValue }) => {
        try {
            const res = await updatePromoAPI(data, promoId);
            return res;
        } catch (error) {
            
            return rejectWithValue(error.response?.data);
        }
    }
);

export const getPlatformProducts = createAsyncThunk('promotion/getPlatformProducts',
       async (data, { rejectWithValue }) => {
        try {
            const res = await fetchPromotionPlatformProducts(data);
            return res;
        } catch (error) {
            
            return rejectWithValue(error.response?.data);
        }
    }
)

export const getPlatformCategory = createAsyncThunk('promotion/getPlatformCategory',
    async (data,{rejectWithValue})=>{
        try{
            const res = await fetchPromotionPlatformCategories(data);
            return res;
        }
        catch(error){
            return rejectWithValue(error.response?.data);
        }
    }
);

export const getPlatformBrands = createAsyncThunk('promotion/getPlatformBrands',
    async (data,{rejectWithValue})=>{
        try{
            const res = await fetchPromotionPlatformBrands(data);
            return res;
        }
        catch(error){
            return rejectWithValue(error.response?.data);
        }
    }
);


export const createPromo = createAsyncThunk(
    'promotion/createPromo',
    async (data, { rejectWithValue }) => {
        try {
            const res = await createPromoAPI(data);
            return res;
        } catch (error) {
            
            return rejectWithValue(error.response?.data);
        }
    }
);

export const downloadPromotionAsPdf = createAsyncThunk(
    'promotion/downloadPromotionAsPdf',
    async ( promotionId, { rejectWithValue }) => {
        try {
            const res = await downloadPromotionAsPdfAPI(promotionId);
            return res;
        } catch (error) {
            
            return rejectWithValue(error.response?.data);
        }
    }
);



export const fetchAllPromotion = createAsyncThunk(
    'promotion/fetchAllPromotion',
    async (data, { rejectWithValue }) => {
        try {
            const res = await fetchPromotionListingAPI(data);
            return res;
        } catch (error) {
            
            return rejectWithValue(error.response?.data);
        }
    }
);

export const getAllPromotions = createAsyncThunk(
    'promotion/getAllPromotions',
    async (data, { rejectWithValue }) => {
        try {
            const res = await getAllPromotionsAPI(data);
            return res;
        } catch (error) {
            
            return rejectWithValue(error.response?.data);
        }
    }
);



export const fetchSinglePromotion = createAsyncThunk(
    'promotion/fetchSinglePromotion',
    async (data, { rejectWithValue }) => {
        try {
            const res = await getSinglePromotionAPI(data);
            return res;
        } catch (error) {
            
            return rejectWithValue(error.response?.data);
        }
    }
);
export const getPromotionData = createAsyncThunk(
    'promotion/getPromotionData',
    async (data, { rejectWithValue }) => {
        try {
            const res = await getPromotionDataAPI(data);
            return res;
        } catch (error) {
            
            return rejectWithValue(error.response?.data);
        }
    }
);


export const deletePromotion = createAsyncThunk(
    'promotion/deletePromotion',
    async (data, { rejectWithValue }) => {
        try {
            const res = await deletePromotionAPI(data);
            return res;
        } catch (error) {
            
            return rejectWithValue(error.response?.data);
        }
    }
);

export const deletePromo = createAsyncThunk(
    'promotion/deletePromo',
    async (data, { rejectWithValue }) => {
        try {
            const res = await deletePromoAPI(data);
            return res;
        } catch (error) {
            
            return rejectWithValue(error.response?.data);
        }
    }
);

export const getPromotionCartRulesByType = createAsyncThunk(
    'promotion/getPromotionCartRulesByType',
    async (data, { rejectWithValue }) => {
        try {
            const res = await getPromotionCartRulesByTypeAPI(data);
            return res;
        } catch (error) {
            
            return rejectWithValue(error.response?.data);
        }
    }
);

export const getPromotionProductRulesByType = createAsyncThunk(
    'promotion/getPromotionProductRulesByType',
    async (data, { rejectWithValue }) => {
        try {
            const res = await getPromotionProductRulesByTypeAPI(data);
            return res;
        } catch (error) {
            
            return rejectWithValue(error.response?.data);
        }
    }
);


// Create your promotionSlice
const promotionSlice = createSlice({
    name: 'promotion',
    initialState: {
        // Your initial state here
        isLoading: false,
        promotionRules: [],
        promotionDetail: {},
        error: null,
        promotions: {}

    },
    reducers: {
        // Other reducers if any
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPromotionCartRulesByType.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getPromotionCartRulesByType.fulfilled, (state, action) => {
                state.isLoading = false;
                state.promotionRules = action.payload;
            })
            .addCase(getPromotionCartRulesByType.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || 'Something went wrong';
            });

        builder
            .addCase(getPromotionProductRulesByType.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getPromotionProductRulesByType.fulfilled, (state, action) => {
                state.isLoading = false;
                state.promotionRules = action.payload;
            })
            .addCase(getPromotionProductRulesByType.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || 'Something went wrong';
            });
        builder
            .addCase(getAllPromotions.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllPromotions.fulfilled, (state, action) => {
                state.isLoading = false;
                state.promotions = action.payload;
                state.promotionDetail = {}
            })
            .addCase(getAllPromotions.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || 'Something went wrong';
            });
        builder
            .addCase(getPlatformProducts.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getPlatformProducts.fulfilled, (state, action) => {
                state.isLoading = false;
                state.promotions = action.payload?.data != null ? { data: action.payload.data, total: action.payload.total } : action.payload;
                state.promotionDetail = {}
            })
            .addCase(getPlatformProducts.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || 'Something went wrong';
            });    
        builder
            .addCase(getPlatformCategory.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getPlatformCategory.fulfilled, (state, action) => {
                state.isLoading = false;
                state.promotions = action.payload?.data != null ? { data: action.payload.data, total: action.payload.total } : action.payload;
                state.promotionDetail = {}
            })
            .addCase(getPlatformCategory.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || 'Something went wrong';
            }); 
        builder
            .addCase(getPlatformBrands.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getPlatformBrands.fulfilled, (state, action) => {
                state.isLoading = false;
                state.promotions = action.payload?.data != null ? { data: action.payload.data, total: action.payload.total } : action.payload;
                state.promotionDetail = {}
            })
            .addCase(getPlatformBrands.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || 'Something went wrong';
            }); 
        builder
            .addCase(fetchAllPromotion.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchAllPromotion.fulfilled, (state, action) => {
                state.isLoading = false;
                state.promotions = action.payload?.data != null ? { data: action.payload.data, total: action.payload.total } : action.payload;
                state.promotionDetail = {}
            })
            .addCase(fetchAllPromotion.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || 'Something went wrong';
            });
        builder
            .addCase(fetchSinglePromotion.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchSinglePromotion.fulfilled, (state, action) => {
                state.isLoading = false;
                state.promotionDetail = action.payload;
            })
            .addCase(fetchSinglePromotion.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
        builder
            .addCase(getPromotionData.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getPromotionData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.promotionDetail = action.payload;
            })
            .addCase(getPromotionData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });

        builder
            .addCase(createPromo.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createPromo.fulfilled, (state, action) => {
                state.isLoading = false;
            })
            .addCase(createPromo.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
        builder
            .addCase(createPromotion.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createPromotion.fulfilled, (state, action) => {
                state.isLoading = false;
            })
            .addCase(createPromotion.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });

        builder
            .addCase(updatePromotion.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updatePromotion.fulfilled, (state, action) => {
                state.isLoading = false;
            })
            .addCase(updatePromotion.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
            builder
            .addCase(updatePromo.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updatePromo.fulfilled, (state, action) => {
                state.isLoading = false;
            })
            .addCase(updatePromo.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export default promotionSlice.reducer;
